import React, { memo } from 'react';
import { defaultHeaderOP, sizeColumn } from '../../styles';

const stylesTh = {
  ...sizeColumn,
  ...defaultHeaderOP,
  height: '25px',
  backgroundColor: '#E6E9ED',
  borderBottom: '1px solid #DDD'
}

const DaysCalendarHeaderFour = (props: any) => {

  return props.daysCal.map(
    (day: any) =>
      day['doctors'] &&
      day['doctors'].map((doctor: any) => (
        <React.Fragment key={day['day'] + doctor['id']}>
          <th
            key={day['day'] + '-op-' + doctor['id']}
            style={stylesTh}
            align='center'
          >
            OP
          </th>
          <th
            key={day['day'] + '-OP以外-' + doctor['id']}
            style={stylesTh}
            align='center'
          >
            OP以外
          </th>
        </React.Fragment>
      ))
  )
};

export default memo(DaysCalendarHeaderFour);
